import React from "react";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { CbObjOnBrand } from "@adyen/adyen-web/dist/types/components/internal/SecuredFields/lib/types";
import cn from "classnames";
import { BrandObject } from "@adyen/adyen-web/dist/types/components/Card/types";
import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";

export const BrandsPicker: ReactTFC<{
  supportedBrands: Array<BrandObject> | Array<CbObjOnBrand>;
  selectedBrand: CbObjOnBrand | null;
  onBrandPicked: (brand: BrandObject | CbObjOnBrand) => void;
}> = props => {
  return (
    <div
      css={css`
        display: flex;
        gap: 10px;
      `}
    >
      {props.supportedBrands.map(brand => {
        return (
          <button
            className={cn({ selected: brand.brand === props.selectedBrand?.brand })}
            onClick={() => props.onBrandPicked(brand)}
            key={brand.brand}
            css={css`
              --h: 32px;
              height: var(--h);

              border-radius: 8px;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 1px;
              margin-right: 4px;

              border: 1px solid transparent;
              &.selected > * {
                border: 1px solid ${CSS_COLORS.Green};
                border-radius: 4px;
                height: var(--h);
              }
            `}
          >
            <img
              css={css`
                width: 100%;
              `}
              src={brand.brandImageUrl}
            />
          </button>
        );
      })}
    </div>
  );
};
